/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * 首页挽留弹窗
 */
import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { RouterV2Enum } from '@/router/router-names';
import AdvHomeBackPopup from '@/components/adv-components/adv-home-back-popup';
import { leaveHomeWebview } from '@/shared/utils/goBack';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';

@Component
export default class AdvertDialog extends Vue {
  private isVisibleAdvert = false

  private backPopupRenderId = '';

  protected controlPopVisible(
    to: Route,
    from: Route, next: (d?: unknown) => void,
    forceCloseWebview?: boolean,
  ) {
    if (HOME_ALL_VERSION_ROUTE_PATHS.includes(to.path as RouterV2Enum)) {
      next(false);

      if (forceCloseWebview) {
        leaveHomeWebview();
      } else {
        this.isVisibleAdvert = true;
        /** 每次退出拦截 都请求刷新广告数据 */
        this.backPopupRenderId = `backPopupRenderId_${Date.now()}`;
      }
    } else {
      next();
    }
  }

  // 广告退出弹窗
  protected renderAdvertDialog() {
    return (
      this.isVisibleAdvert && <AdvHomeBackPopup key={this.backPopupRenderId} />
    );
  }
}
